import { toIsoString } from 'framework/utils/datetimes';

const getFieldValue = (field) => field?.value || field;

/**
 * Serializes rule/filter values for API payload.
 * For IsBetween operation, converts Date values to ISO strings; otherwise uses String().
 * Filters out null/undefined to avoid sending "null"/"undefined" strings or invalid payload elements.
 */
export const serializeRuleValues = (raw: unknown, operation: string): string[] => {
  if (!raw) return [];
  const rawWithValue = raw as { value?: unknown };
  let arr: unknown[];
  if (rawWithValue.value !== undefined && rawWithValue.value !== null) {
    arr = [raw];
  } else if (Array.isArray(raw)) {
    arr = raw;
  } else {
    arr = [raw];
  }
  const values = arr
    .map((item) => getFieldValue(item))
    .filter((value): value is NonNullable<typeof value> => value != null);
  if (operation === 'IsBetween') {
    return values.map((value) => toIsoString(value)).filter((value): value is string => value != null);
  }
  return values.map(String);
};
